"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasVcContext = hasVcContext;
function hasVcContext(val) {
    const obj = val;
    if (typeof obj !== "object" || !("ctx" in obj)) {
        return false;
    }
    const ctx = obj.ctx;
    return (typeof ctx === "object" &&
        typeof ctx.logger === "object" &&
        typeof ctx.support === "object" &&
        typeof ctx.videoClient === "object");
}
//# sourceMappingURL=vc-context.js.map